module.exports = __webpack_public_path__ + "img/contacto_over.78227b1d.gif";